<template>
  <pt-live-list class="pt-live-list__withData"></pt-live-list>
</template>

<script>
import PtLiveList from './index'
export default {
  name: 'pt-live-list__withData',
  components: {
    'pt-live-list': PtLiveList
  }
}
</script>
